import { render, staticRenderFns } from "./shipment_list.vue?vue&type=template&id=2939735e&"
import script from "./shipment_list.vue?vue&type=script&lang=js&"
export * from "./shipment_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports